(()=>{if(customElements.get('faq-search')){return}
class faqSearch extends HTMLElement{constructor(){super();this.searchField=this.querySelector('[data-search-field]');this.blocks=JSON.parse(this.dataset.blocks);this.resultsContains=document.querySelector('[data-search-results-tab]',);this.tabTitle=document.querySelector('[data-tab-title-container]');this.searchTerm=''}
connectedCallback(){this.attachEvents()}
attachEvents(){this.debouncedInput=debounce(()=>{this.searchTerm=this.searchField.value.trim();if(this.searchTerm.length>0){this.findMatches(this.searchTerm);this.showResults()}else{this.hideResults('event')}},500);this.searchField.addEventListener('input',this.debouncedInput.bind(this),);document.querySelectorAll('[data-tabs-nav-element]').forEach((navigationElement)=>{navigationElement.addEventListener('click',()=>{this.hideResults();this.searchField.value=''})})}
findMatches(){let matchedResults=[];this.blocks.forEach((block)=>{const regSearchTerm=new RegExp(this.searchTerm,'i');if(block.title.search(regSearchTerm)!=-1||block.content.search(regSearchTerm)!=-1){matchedResults.push(block)}});if(matchedResults.length===0){const noResultsMessage=this.generateNoResultsMessage();this.appendResults(noResultsMessage)}else{this.generateResults(matchedResults)}}
generateResults(matchedResults){let resultsMarkup='';matchedResults.forEach((result)=>(resultsMarkup+=this.generateAccordionTemplate(result)),);this.appendResults(resultsMarkup)}
showResults(){this.resultsContains?.classList.add('is-current');this.changeTitleContainer();document.dispatchEvent(new Event('faqSearchActive'))}
hideResults(event){this.resultsContains?.classList.remove('is-current');if(event){document.dispatchEvent(new Event('faqSearchInactive'))}}
changeTitleContainer(){this.tabTitle.textContent=`${this.dataset.tabTitle} "${this.searchTerm}"`}
appendResults(results){this.resultsContains.innerHTML=results}
generateNoResultsMessage(){return `<div class="faq__tab-empty">${this.dataset.noResults}</div>`}
generateAccordionTemplate(accordionData){return `<accordion-item class="accordion-item">
        <header class="accordion-item__head" data-trigger>
          <h4>${accordionData.title}</h4>

          <div class='accordion-item__trigger'>
            <svg width="18" height="11" viewBox="0 0 18 11" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M17 1L9 9L1 1" stroke="currentColor" stroke-width="2"/>
            </svg>
          </div><!-- /.accordion-item__trigger -->
        </header>

        <div class='accordion-item__body' data-body>
          <div class='accordion-item__inner' data-content>
            <div class='accordion-item__entry'>
              ${accordionData.content}
            </div><!-- /.accordion-item__entry -->

            ${
              accordionData.image
                ? `<div class='accordion-item__image'><div class="media media--aspect-ratio media--transparent accordion-item__media"><noscript><img
sizes="auto"
src="${accordionData.image}"></noscript><img
data-sizes="auto"
data-src="${accordionData.image}"
class="lazyload no-js-hidden"></div><!--/.media --></div><!--/.accordion-item__image -->`
                : ''
            }
          </div><!-- /.accordion-item__inner -->
        </div><!-- /.accordion-item__body -->
      </accordion-item>`}}
customElements.define('faq-search',faqSearch)})()